import { useSyncExternalStore } from 'react';

import { type EffectiveTheme, getEffectiveTheme, onEffectiveThemeChange } from '@/preferences/theme-preference';

/** The applied interface theme (light/dark), for components that must pass it
 *  on explicitly (e.g. sonner's Toaster). */
export function useEffectiveTheme(): EffectiveTheme {
    return useSyncExternalStore(onEffectiveThemeChange, getEffectiveTheme, () => 'light' as const);
}
